import { render, staticRenderFns } from "./ListMerchants.vue?vue&type=template&id=2606ca65&scoped=true&"
import script from "./ListMerchants.vue?vue&type=script&lang=js&"
export * from "./ListMerchants.vue?vue&type=script&lang=js&"
import style0 from "./ListMerchants.vue?vue&type=style&index=0&id=2606ca65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606ca65",
  null
  
)

export default component.exports